/**
 * Format a date string to 'YYYY-MM-DD HH:mm' or 'YYYY-MM-DD' (date only).
 * For plain date strings (YYYY-MM-DD), appends T12:00:00 to avoid UTC boundary shift.
 * @param dateString - The date string to format
 * @param mode - 'date' for date only, otherwise includes time
 * @return {string} - The formatted date string
 */
export function formatDate(dateString, mode) {
    const raw =
        typeof dateString === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateString)
            ? `${dateString}T12:00:00`
            : dateString;
    const date = new Date(raw);
    if (Number.isNaN(date.getTime())) return '';
    const y = date.getFullYear();
    const mo = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    if (mode === 'date') return `${y}-${mo}-${d}`;
    const h = String(date.getHours()).padStart(2, '0');
    const mi = String(date.getMinutes()).padStart(2, '0');
    return `${y}-${mo}-${d} ${h}:${mi}`;
}
